import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div>
            <div className="row team-header">
                <div className="col-md-12">
                    <h1>Team Buzz </h1>
                    <p>A football team information hub</p>
                </div>
            </div>
        </div>
    );
};

export default Header;